exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .searchIn{border:1px solid #2a2c2f;border-radius:5px}}\n:root[data-theme=dark] .searchIn{border:1px solid #2a2c2f;border-radius:5px}\n.searchIn__input{width:100%}\n", ""]);

// exports
exports.locals = {
	"searchIn": "searchIn",
	"searchIn__input": "searchIn__input"
};